import { Checkbox, Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { REQUEST_PACKAGES } from 'src/graphql/packages.graphql'
import { PackageType } from 'src/graphql/types/package'
import { formatSnakeValue } from 'src/lib/formatters'

import { inlineSelectProps } from './inlineSelectStyles'

const OrderOptions = ({
  selectedOrder,
  setSelectedOrder,
  fcraLegalRequirementsConsent,
  setFcraLegalRequirementsConsent,
}) => {
  const { data: orders } = useQuery(REQUEST_PACKAGES)
  const orderList =
    orders?.packages?.map((p) => ({
      value: p.packageId,
      label: `${formatSnakeValue(p.packageType)} - ${p.name}`,
      stepTypes: p.stepType,
    })) || []

  const selectedPackage = orders?.packages?.find(
    (pkg) => pkg.packageId === selectedOrder?.packageId
  )

  return (
    <div className="flex flex-col gap-3 text-xs">      {orderList.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No orders found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedOrder?.packageId}
          onChange={(value) => {
            const newSelectedPackage = orders?.packages?.find(
              (pkg) => pkg.packageId === value
            )
            if (newSelectedPackage?.packageType == PackageType.HIRE_RIGHT) {
              setSelectedOrder({
                packageId: value,
                fcraLegalRequirementsConsent: false,
              })
            } else {
              setSelectedOrder({ packageId: value })
            }
          }}
          data={orderList}
          className="max-w-sm"
          searchable
        />
      )}
      {/* Conditional FCRA Consent */}
      {selectedPackage?.packageType === PackageType.HIRE_RIGHT && (
        <div className="mt-2 flex flex-col gap-2 text-xs">
          <Checkbox
            size="xs"
            checked={fcraLegalRequirementsConsent}
            onChange={(e) =>
              setFcraLegalRequirementsConsent(e.currentTarget.checked)
            }
            label={
              <span>
                I have read and complied with the{' '}
                <a
                  href="https://ows01.hireright.com/legal_requirements.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline hover:text-blue-800"
                >
                  Legal Requirements
                </a>{' '}
                for requesting a background check{' '}
                <span className="text-red-500">*</span>
              </span>
            }
            required
          />
        </div>
      )}
    </div>
  )
}

export default OrderOptions
